<template>
<div class="container py-6">
  <div class="row">
    <div class="col-48 text-start px-xl-0 px-3">
<p v-html="data" ></p>

    </div>
  </div>
</div>
  

</template>

<script>
// import { dataPromise } from '@/stores/store.js';
export default {
name: 'About',
data () {
      return {
    data: '', 
 }
 },
 created() {
   const dataPromise = fetch('https://wanada.org.au/wp-json/wp/v2/pages/2712').then(value => value.json());
    dataPromise.then(data => {
  // console.log(data);
  this.data = data.content.rendered
  this.searchServices();
   console.log('created');
});
 }
}



</script>

<style>

</style>
